import { ModelBase } from 'store/model-base';

export class CmsMyAccountModals extends ModelBase {
    public static storeName: string = 'cmsMyAccountModals';

    public modals: MyAccountModals;
}
